import React from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import logoImage from '../../images/brand/logo.png';

const useStyles = makeStyles((theme) => ({
  branding: {
    width: '280px',
    padding: `${theme.spacing(6)}px ${theme.spacing(4)}px`,
  },
  brandingLogo: {
    marginTop: `${theme.spacing(2)}px`,
    width: '100%',
    maxWidth: '180px'
  },
  brandingText: {
    color: theme.palette.text.hint,
    fontFamily: "'Raleway', sans-serif",
    fontWeight: '500',
    lineHeight: '27pt',
  },
}));

export default function LoginBrand() {
  const classes = useStyles();

  return (
    <Grid
      item
      xs
    >
      <div className={classes.branding}>
        <Typography className={classes.brandingText} variant="h4">welcome</Typography>
        <Typography className={classes.brandingText} variant="h4">to</Typography>
        <img
          className={classes.brandingLogo}
          alt="iCompare Logo"
          src={logoImage}
        />
      </div>
    </Grid>
  );
};